import { overrideWidgetSectionConfig } from './utils'; // Transform active chart section to gauge chart

const chartAdapter = (sectionId, widget) => overrideWidgetSectionConfig(sectionId, widget, 'GaugeChart', {
  selectionsStrategy: 'default',
  selectionsLabeled: false,
  hasGradualColors: false
});

export default chartAdapter;